<app-page-header
  class="header"
  coreActivitySection="Header"
  coreUserActivityClickTracking="ClosePromos"
  backButtonText="Back"
  [backSwipe]="backSwipeConfig"
  (click)="back.emit()"
/>

@if (loading()) {
  <app-loading/>
} @else {
  @let specials = this.specials();

  @if (specials && specials.length > 0) {
    <swiper-container
      class="swiper"
      [autoplay]="false"
      [pagination]="true"
      [direction]="'vertical'"
      [loop]="true"
    >
      @for (slide of specials; track slide.id; let i = $index) {
        @if (slide.contentType === 'image') {
          <swiper-slide>
            <img class="slide" [src]="slide.contentLocal" alt="Promo {{ i + 1 }}"/>
          </swiper-slide>
        } @else if (slide.contentType === 'video') {
          <swiper-slide>
            <video swiperControl class="slide" autoplay muted loop [src]="slide.contentLocal"></video>
          </swiper-slide>
        }
      }
    </swiper-container>
  } @else {
    <div class="empty">
      No promotions available at this time.
    </div>
  }
}
